import { sdkLogger } from '../logger/logger';
import type { AnalyticsEvent } from './types';

export function trackEvent(event: AnalyticsEvent) {
  if (event.eventName === 'survey_session_summary') {
    const {
      completed,
      totalDurationMs,
      maxVisitedPageIndex,
      totalQuestionsCount,
      answeredQuestionsCount,
      skippedQuestionsCount,
      skippedQuestionIds,
      validationErrorsCount,
      backtrackCount,
    } = event.metadata;

    // Always log to console with Heading as ANALYTICS
    sdkLogger.analytics(`Event: ${event.eventName} - SESSION SUMMARY TABLE:`);

    const summaryTable = [
      { Metric: 'Completion Status', Value: completed ? 'COMPLETED ✅' : 'ABANDONED ❌' },
      { Metric: 'Total Time Spent', Value: `${(totalDurationMs / 1000).toFixed(2)} seconds` },
      { Metric: 'Max Page Index Reached', Value: `${maxVisitedPageIndex}` },
      { Metric: 'Total Questions', Value: totalQuestionsCount },
      { Metric: 'Answered Questions', Value: answeredQuestionsCount },
      { Metric: 'Skipped Optional Questions', Value: skippedQuestionsCount },
      { Metric: 'Skipped Question IDs', Value: skippedQuestionIds.join(', ') || 'None' },
      { Metric: 'Validation Errors Triggered', Value: validationErrorsCount },
      { Metric: 'Backtrack Count', Value: backtrackCount },
      {
        Metric: 'Validation Error History',
        Value:
          event.metadata.validationHistory
            ?.map(
              h =>
                `[Page ${h.pageIndex}] Attempt ${h.attemptNumber}: ${Object.keys(h.errors).join(', ')}`
            )
            .join(' | ') || 'NO Validation Erros Occurred',
      },
    ];

    console.table(summaryTable);
  } else if (event.eventName === 'logic_session_summary') {
    sdkLogger.analytics('Event: logic_session_summary - LOGIC ANALYSIS TABLE:');

    const countsTable = [
      { 'Logic Kind': 'Display logic matches', Count: event.metadata.displayLogicMatches.length },
      { 'Logic Kind': 'Answer logic matches', Count: event.metadata.answerLogicMatches.length },
      { 'Logic Kind': 'Variant matches', Count: event.metadata.variantMatches.length },
      {
        'Logic Kind': 'End page changes',
        Count: event.metadata.endPageResolution.changeCount,
      },
      { 'Logic Kind': 'Skip logic triggers', Count: event.metadata.skipLogicTriggers.length },
      { 'Logic Kind': 'Questions viewed', Count: event.metadata.viewedCount },
      {
        'Logic Kind': 'On-path questions not viewed',
        Count: event.metadata.notViewedOnPathCount,
      },
    ];

    console.table(countsTable);

    if (event.metadata.logicEventTimeline.length > 0) {
      console.table(event.metadata.logicEventTimeline);
    }
  } else {
    // Always log to console with Heading as ANALYTICS
    sdkLogger.analytics(`Event: ${event.eventName}`, event.metadata);
  }
}
